export default "__VITE_ASSET__yrBNbpn4__"